import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useUserTimezone } from "hooks/useUserTimezone";
import {
    CalendarFriendlyEvent,
    dateToDisplay,
    dayToDisplay,
    formatDate,
    timeToDisplay,
} from "./types";

type EventRegistrationModalProps = {
    isOpen: boolean;
    onClose: (open: boolean) => void;
    event: CalendarFriendlyEvent;
};

export function EventRegistrationModal({ isOpen, onClose, event }: EventRegistrationModalProps) {
    const timeZone = useUserTimezone();
    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Overlay className="fixed inset-0 z-50 bg-[#424242]/75" />
            <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[500px] max-w-[90%] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-xl">
                <div className="mb-2 flex items-center justify-between">
                    <h2 className="text-lg font-semibold ">Register for the event</h2>

                    <Dialog.Close>
                        <X className="h-5 w-5 text-gray-500 hover:text-black" />
                    </Dialog.Close>
                </div>
                <div className="mb-3 h-[1px] w-full bg-[#e0e0e0]" />

                <div className="mb-3 space-y-3">
                    <div className="font-medium">Event details</div>
                    <div className="flex flex-row rounded bg-[#def1fa] p-3 text-sm">
                        <strong className="mr-1 block">Event name: </strong>
                        {event.title}
                    </div>
                    <div className="flex flex-row rounded bg-[#def1fa] p-3 text-sm">
                        <strong className="mr-1 block">Date and time: </strong>
                        {dayToDisplay(new Date(event.start), timeZone)} from{" "}
                        {event.start ? timeToDisplay(new Date(event.start), timeZone) : ""}
                    </div>
                    <div className="flex flex-row rounded bg-[#def1fa] p-3 text-sm">
                        <strong className="mr-1 block">Location: </strong>
                        {event.location} -{" "}
                        <div className=""> A link will be provided closer to the date</div>
                    </div>
                </div>
                <div className="mb-4 h-[1px] w-full bg-[#e0e0e0]" />
                <div className="space-y-2">
                    <label className="block text-sm font-medium">Confirm your information</label>
                    <input
                        type="email"
                        className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-[#2da8e0]/50"
                        placeholder="you@example.com"
                    />
                    <div className="mt-2 flex items-center gap-2">
                        <input type="checkbox" checked id="reminder" className="accent-[#e0e0e0]" />
                        <label htmlFor="reminder" className="text-sm text-gray-700">
                            Do you want to receive reminders for this event?
                        </label>
                    </div>
                </div>

                <div className="mt-5 text-right">
                    <button className="rounded bg-[#2da8e0] px-4 py-2 text-sm font-medium text-white hover:bg-[#2494c7]">
                        Finish registration
                    </button>
                </div>
            </Dialog.Content>
        </Dialog.Root>
    );
}
